Namespace 'Monitoring.Reports.Publications'

class Monitoring.Reports.Publications.ReportView extends Backbone.View

  className: 'publications-report'

  events:
    'click #build': 'build'
    'click #pdf': 'exportPDF'

  initialize: (@options = {}) ->

  render: =>
    @header = new Monitoring.Reports.Publications.HeaderView(@options)
    @header.render()
    @$el.html(@header.el)
    @

  build: =>
    reportView =
      if @options.contents[0].type == 'twitter'
        new Monitoring.Reports.Publications.TwitterReportView @options, @header
      else
        new Monitoring.Reports.Publications.FacebookReportView @options, @header
    @$el.append reportView.build().el
    @listenTo reportView, 'download-pdf:toggle', ({disabled}) =>
      @$('.download-pdf').prop 'disabled', disabled

  exportPDF: -> window.print()
